module.exports = __webpack_public_path__ + "img/tier4-more-info.78a18ae.svg";